import { render, staticRenderFns } from "./XyIndex.vue?vue&type=template&id=87fe5eea&scoped=true&"
import script from "./XyIndex.vue?vue&type=script&lang=js&"
export * from "./XyIndex.vue?vue&type=script&lang=js&"
import style0 from "./XyIndex.vue?vue&type=style&index=0&id=87fe5eea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe5eea",
  null
  
)

export default component.exports